import { format } from 'date-fns';

/**
 * A small function returns the current day of the week, formatted either in a
 * short or full form based on the optional `variation` parameter.
 */
export function getCurrentWeekDay(variation: 'short' | 'full' = 'short') {
  return format(new Date(), variation === 'short' ? 'EEE' : 'EEEE');
}
